import axios from "axios";
import { HttpStatus, OperationStatus } from "./Constants";
import { clearState } from "../Redux/localStorage";

let interceptorResponse;
export const initializeInterceptors = (refreshTokenAction) => {
	interceptorResponse = axios.interceptors.response.use(
		(res) => {
			return res;
		},
		(error) => {
			return new Promise((resolve, reject) => {
				if (error.response && (error.response.status === HttpStatus.UNAUTHORIZED)) {
					refreshTokenAction((apiInfo) => {
						let config = error.config;
						if (apiInfo.data.data) {
							let newAccessToken = apiInfo.data.data.accessToken;
							config.headers.Authorization = "Bearer " + newAccessToken;

							axios
								.request(config)
								.then((data) => {
									resolve(data);
								})
								.catch((error) => {
									reject(error);
								});
						} else if (apiInfo.status === OperationStatus.FAILURE) {
							clearState();
							window.location.reload()
							
						}
					});
				} else {
					reject(error);
				}
			});
		}
	);
};

export const removeInterceptors = () => {
	interceptorResponse && axios.interceptors.response.eject(interceptorResponse);
};